export class Semaphore {
  private max: number;
  private queue: Array<{
    resolve: () => void;
    reject: (error: Error) => void;
  }> = [];
  private count = 0;

  constructor(max: number) {
    this.max = max;
  }

  async acquire() {
    if (this.count >= this.max) {
      await new Promise<void>((resolve, reject) => {
        this.queue.push({ resolve, reject });
      });
    }
    this.count++;
  }

  release() {
    this.count--;
    if (this.count < 0) {
      this.count = 0;
    }

    const next = this.queue.shift();
    if (next) {
      next.resolve();
    }
  }

  clear() {
    while (this.queue.length > 0) {
      const next = this.queue.shift();
      if (next) {
        next.reject(new Error('Semaphore cleared'));
      }
    }
    this.count = 0;
  }
}
